var MessageEn = {

  NavabarText: {
    navbar_home: "Home",
    navbar_about: "About Us",
    navbar_product:"Product",
    navbar_academic_trends: "Academic Trends",
    navbar_contact: "Contact Us",
    navbar_item: "Corporate Social Responsibility",
    navbar_item_story:'Responsibility Story',
    support_part:'Support and love the Party',
    navbr_new: 'News',
    navbr_join:'Join Us',
    
    navbr_new_one: 'News Information',

    
    navbr_child_about_1: 'Company Introduction',
    navbr_child_about_2: 'Qualification&Honor',
    navbr_child_about_3: 'Corporate Culture',
    navbr_child_about_5:'Culture Slogan',
    navbr_child_about_4:'Developing Road',


    navbr_child_news_1: 'Company Information',
    navbr_child_news_2: 'Industry Dynamics',

    navbr_child_case_1: 'Academic Live Broadcast',
    navbr_child_case_2: 'Classic Video',
    navbr_child_case_3:'Academic conferences',

    navbr_child_join_1: 'Talent Concept',
    navbr_child_join_2: 'Talent Recruitment',
    navbr_child_join_3: 'Career Development',
    product_introduct:'Product Introduction',
    
    company_introduct:'Company Profile',
    company_team:'Company Team',
    company_person:'Humanistic care',
    company_env:'Company Environment',
    team_culture:'Team culture',
    team_culture_desc:'Survival within eight hours, development beyond eight hours',
    company_culture_title:'Corporate philosophy:',
    company_culture_desc:' Honesty, Principle, Efficiency and Gratitude.',
    company_news:'Company News',
    navbr_item_desc:"In the long-term social responsibility management and practice, entropy has consciously organically unified undertaking historical mission, fulfilling social responsibility and promoting sustainable development of enterprises, and gradually formed a social responsibility management model with its own characteristics - mission leading social responsibility management. The model covers sub modules such as responsibility culture, responsibility management and responsibility practice, and defines the objectives, guiding ideology, responsibility areas, organizational motivation and work path of entropy's social responsibility work. It is the general idea and action line of entropy's social responsibility work.",


    join_us:'Join Us',
    contact_us_desc: 'Entropy does not forget its original intention, and has always adhered to the mission of "helping a healthy life" to forge ahead!',
    salon_one: 'The First Precision Minimally Invasive Surgery Conference for Gastrointestinal Tumors by Zhuo Yue Nan Medical (Sign in and Photo)',
    salon_two: '2024 Southern Medical Surgery New Sailing Conference (4th)',
    salon_three: "2024 National Key R&D Program Project Promotion Meeting' Demonstration Research on Domestic Innovative Medical Electric Stapler Application ",
    salon_four: 'Annual Work Meeting of Guangdong General Surgery (Gastrointestinal) Professional Quality Control Center',
    salon_five: 'Annual Meeting of the Minimally Invasive Surgery Branch of Guangdong Medical Association and the First Youth Physician Gastrointestinal Minimally Invasive Surgery Video Competition',
    salonxix: 'Guangzhou High tech (Precision Minimally Invasive Surgery Technology 2023D-ZD01) Promotion Conference and Southern Alumni Forum',
    company_culture_desc_1: 'Strive for survival within eight hours, and seek development beyond eight hours.',
    company_culture_desc_2: 'Over learning, over training oneself',
    company_culture_desc_3:'If the performance is not good, it proves that you are not working hard enough',
    company_culture_desc_4: 'Emphasize integrity, principles, rules, and efficiency',
    company_culture_desc_5: 'Goals, ideas, actions',
    company_culture_desc_6: 'Past, Present, Future',
    company_culture_desc_7: 'Loyalty and character are greater than ability.',
    company_culture_desc_8: 'Enrich your thoughts with gratitude and let your actions practice your gratitude.',
    company_culture_desc_9: 'Get things done at once',
    company_culture_desc_10: 'Winning comes from a sense of responsibility, winning comes from execution.',

  },
  About_Navbar: {
     company: 'Company Overview',
    Horor: 'Awards & Accreditation',
    Technology: 'Technology ',
    Team: 'Our Team ',
    introduct:'Guangzhou Entropy Trade Co., Ltd. is a company that operates and sells medical devices, equipment, consumables, and other products, as well as integrates production, research, and transformation. The company provides comprehensive medical product service solutions to major tertiary hospitals, outpatient clinics, and other medical institutions with rich products, professional technical services, perfect after-sales services, and specialized research and development services. The product types cover all hospital surgical systems (operating rooms, obstetrics and gynecology, urology, pediatrics, proctology, breast, gastroenterology, thoracic surgery, hepatobiliary, etc.).',
    team_desc:"The company aims to prioritize service, operate with integrity, and achieve win-win cooperation; A young and vibrant sales team with a bachelor's degree or above, possessing multidisciplinary professionals in medicine, pharmacy, enterprise management, and other fields; Committed to serving a customer with efficient, professional, progressive, and pragmatic team strength in the medical market, our excellent employee team has laid a solid foundation for the rapid development of Entropy Da, striving to become a leader in the industry.",
    eve:"The warm working environment and harmonious working atmosphere are conducive to promoting the harmony of interpersonal relations, stimulating employees' self-improvement, improving work efficiency and promoting the development of the enterprise.",
    
    eve_person:'At Entropy, we take humanistic care as the core and create a warm home for growth. We provide our employees with:Paid travel, employee parental care, afternoon tea, quarterly team building, healthy exercise, birthday benefits, annual leave, annual physical examination, onboarding gift package, annual gift package, good training mechanism, mentorship mechanism .....',

    eve_person_1:"Through team activities that change with the seasons, exclusive customized starlight days, poetic travel experiences, and filial piety relay of family care, we enable every partner to feel a sense of belonging through laughter and growth. Whether it's the seamless collaboration in outdoor expansion, the unique moments of birthday surprises, or the nourishment and exploration in the mountains and waters, we weave an emotional network with our heart, extending care to employees' families and allowing warmth to flow in both directions. Here, enterprises are not only platforms for careers, but also harbors for emotions. We exchange sincerity for sincerity, allowing every striving figure to move forward firmly in warmth and create greater value together.",
  },

  New_NavBar: {
    Notice: 'Notice',
    MediaCentre: 'Media  centre',
  },
  indexText: {
    more: "More",
   

  },
  footText: {
     companys: 'Guangzhou entropy Da Trade Co., Ltd',
    address: "Address:Baiyun District, Guangzhou.",
    addresss: " Baiyun District, Guangzhou.",
    phone: "Tel ",
    email: "Email",
    address_s: "Address",
    weixin: "Scan QR  code",
    aboutUs: 'About Us',
    company: 'Company',
    news: 'News ',
    notice: 'Notice',
    mediaCentre: 'Media  centre',
    report: 'Report ',
     contact: 'Contact Us',
    talentRecruitment: 'Career',
    OfficeHours: 'Office Hours',
    day1: 'Mon - Fri',
    day2: 'Sat - Sun',
    version: 'All rights reserved © 2021-2022 Guangzhou entropy Da Trade Co., Ltd',
    back: 'Back'
  },
  contractText: {
   
    termsofuse:'All rights reserved © 2021-2022 Guangzhou entropy Da Trade Co., Ltd',
  },
 
  AboutUs: {
    h_c: 'About Us',
  
  },
   concat: {
    h_t: 'Contact Us',
    form_t: 'Get in touch',
    ph_1: 'Message',
    
    name: 'Please enter your name',
    phone:'Please enter your phone',
    need:'Please enter your requirements',
     codemsg:'Please enter the verification  code',
    ph_3: 'Mobile No.',
    ph_4: 'Email',
    sub_t: 'Submitted',
    location: 'Room 403a, 4 / F, No. 668-2, shatai Road, Jingxi street, Baiyun District, Guangzhou..'
  },
  VideoText:{
    video_one_abstract: 'Laparoscopic radical resection of right colon cancer',
    video_one_date:'2021-06-22',
    video_one_desc: 'Laparoscopic radical resection of right colon cancer is suitable for the treatment of malignant tumors such as the left half of transverse colon, hepatic flexure of colon, ascending colon and appendix. Laparoscopic surgery is becoming more and more popular in colorectal cancer surgery because of its advantages of small trauma and fast recovery. Several clinical studies have confirmed that radical resection of right colorectal cancer under the guidance of CME theory can maximize the scope of lymph node dissection, reduce the risk of local recurrence and distant metastasis, and prolong the overall survival.',
    video_two_abstract: 'Laparoscopic radical gastrectomy',
    video_two_date:'2018-02-11',
    video_two_desc: 'Laparoscopic radical gastrectomy is a radical gastrectomy with the help of laparoscopic technology. Make a 1 cm hole in the umbilicus, place the puncture device, and then inject carbon dioxide gas to uplift the abdomen. Put the puncture device into the camera, and you can observe the whole abdominal cavity. 0.5 for left and right upper abdomen respectively × 1.5cm holes, 2 holes each. Put the puncture device into the ultrasonic scalpel and forceps for operation, cut off the blood vessels around the stomach, clean the lymph nodes around the stomach, cut off the small mouth of the upper abdomen about 10cm, remove the stomach and surrounding omental lymph nodes, and perform gastrointestinal anastomosis. Endoscopic minimally invasive surgery has less trauma and faster recovery after operation. It is one of the commonly used surgical methods at present.',
    
    },
    productIntroduct:{
      product_desc:'Entropy Da is committed to the fields of product R & D and production, medical device sales and cultural services in the medical industry. With rich products, professional technical services and perfect after-sales services, it provides perfect medical product service solutions for major class III hospitals, outpatients and other medical institutions. The product types include operating room, Obstetrics and Gynecology, Urology, pediatrics Anorectal, breast, gastrointestinal and other surgical systems.',
      product_one:'Foreskin gun',
      product_two:'Disposable cavity mirror linear cutting closer',
      product_three:'Minimally invasive fascia closure device (minilap)',
    },
    
  
    honor:{
      start: 'Start up ',
      item_1: '2014: The company was established',
      item_2: '2015: Signed cooperation with medical product manufacturers for the first time',
      item_3: '2016: Cooperation with many industry-leading medical product companies',
      item_4: '2017: The business scope was expanded and covered to serve a number of top three hospitals',
      item_5: '2018: Become the general agent of Guangdong Province for multiple brand products and establish cooperation with multiple product platforms',
      item_6: '2019: Create patent R & D projects, incubate their own product brands and serve the national market',
      item_7: '2020: Build an academic resource platform and optimize the strategic development framework. Establish the development direction of collectivization ',
      item_8: '2021: Won the honorary title of "contract abiding and trustworthy enterprise" in 2021, and the equipment won the bid for three top three hospitals',
      end:'Work hard and perseveringl',
    },
    corporate:{
      item_1: 'Enterprise mission',      
      item_1_desc: 'Help healthy life',      
      item_2: 'Corporate vision',      
      item_2_desc: 'Become the leader of the health industry',      
      item_3: 'Enterprise spirit',      
      item_3_desc: 'Win trust with integrity and decide success or failure with details',      
      item_4: 'Enterprise slogan',      
      item_4_desc: 'Work hard, live a healthy life, unite and love, and create good achievements together',      
    },
    concept:{
      item_1: 'Adhering to the original mission of "helping a healthy life", entropy is built into an organization that embraces all rivers. In this organization, ordinary people become excellent people, excellent people become excellent people, and a steady stream of people realize their life dreams here.',
      item_2: "Cultivating and bringing up a talent team that wins market leadership, creates organizational advantages, leads value orientation, has a sense of mission and responsibility, and supports the realization of strategic objectives is entropy's continuous talent pursuit.",
      item_3:'Entryda cares for employees from the aspects of life, emotion and growth.',      
      item_4: "Entropy people cherish their inner dreams and pursuits, because dreams make them more energetic, more creative, more motivated to surpass other organizations and individuals, and realize the sublimation of their own realm.",
      item_5: 'Talent management starts from the needs of strategic and organizational development, focuses on the construction of entropy talent team, forms a differentiated management system for different talent groups, and forms a closed-loop management of talent standards, planning, selection, training, use and retention. ',
      item_6: "Entryda promotes employees in key positions to have multi post, cross functional and cross industry experience, constantly optimizes the matching degree between people and positions, people and teams, people and organizations, improves the structure and level of talent team, and maintains the passion and vitality of the organization.",
      
    },
    postData:{
        name: 'Name',        
        name_placeholder: 'Please fill in your name',        
        phone: 'Phone',        
        phone_placeholder: 'Please fill in the contact information',        
        post: 'Post',        
        post_placeholder: 'Please select a position to apply for',  
        submit:'Submit'      
    },
};

export {
  MessageEn
}



// WEBPACK FOOTER //
// ./src/i18n/lang/en.js